import React, { useEffect } from "react";
import "../styles/MessageInfoModal.css";

const MessageInfoModal = ({ isVisible, info, onClose }) => {
  useEffect(() => {
    if (!isVisible) return undefined;

    const onEsc = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("keydown", onEsc);
    };
  }, [isVisible, onClose]);

  if (!isVisible || !info) return null;

  const readByUsers = Array.isArray(info.readBy) ? info.readBy : [];
  const isReadByOnlyView = Array.isArray(info.readBy);

  return (
    <div className="message-info-backdrop" onClick={onClose}>
      <div
        className="message-info-card"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="message-info-top">
          <div>
            <p className="message-info-kicker">
              {isReadByOnlyView ? "Message Status" : "Message Details"}
            </p>
            <h3>{isReadByOnlyView ? "Read by" : "Info"}</h3>
          </div>
          <button
            type="button"
            className="message-info-close-btn"
            onClick={onClose}
            aria-label="Close message info"
          >
            X
          </button>
        </div>

        {!isReadByOnlyView && (
          <>
            <div className="message-info-preview">{info.text}</div>

            <div className="message-info-grid">
              <div className="message-info-row">
                <span>Time</span>
                <strong>{info.timestamp}</strong>
              </div>
              <div className="message-info-row">
                <span>Status</span>
                <strong className="status-chip">{info.status}</strong>
              </div>
              <div className="message-info-row">
                <span>Type</span>
                <strong>{info.messageType}</strong>
              </div>
              <div className="message-info-row">
                <span>From</span>
                <strong>{info.from}</strong>
              </div>
              <div className="message-info-row">
                <span>To</span>
                <strong>{info.to}</strong>
              </div>
              <div className="message-info-row">
                <span>ID</span>
                <strong className="message-id-value">{info.id || "N/A"}</strong>
              </div>
            </div>
          </>
        )}

        {Array.isArray(info.readBy) && (
          <div className="message-readby-section">
            <p className="message-readby-title">
              Read by ({info.readCount ?? readByUsers.length}
              {info.recipientCount ? `/${info.recipientCount}` : ""})
            </p>
            {readByUsers.length === 0 ? (
              <p className="message-readby-empty">
                No members have read this message yet.
              </p>
            ) : (
              <div className="message-readby-list">
                {readByUsers.map((entry, index) => (
                  <div
                    key={`${entry.userId || entry.username || "member"}-${index}`}
                    className="message-readby-item"
                  >
                    <strong>{entry.username || "Unknown member"}</strong>
                    <span>
                      {entry.readAt
                        ? new Date(entry.readAt).toLocaleString()
                        : "Read time unavailable"}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <div className="message-info-actions">
          <button
            type="button"
            className="message-info-done-btn"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageInfoModal;
